import { render, staticRenderFns } from "./news12.vue?vue&type=template&id=515045d2&scoped=true&"
import script from "./news12.vue?vue&type=script&lang=js&"
export * from "./news12.vue?vue&type=script&lang=js&"
import style0 from "./news12.vue?vue&type=style&index=0&id=515045d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515045d2",
  null
  
)

export default component.exports